export default __webpack_public_path__ + "static/media/xai.88c4745a.png";